import { MessageCircle, Phone, Mail, MapPin } from "lucide-react";
import { IMAGES, PHONE_TEL, PHONE_DISPLAY, WA_LINK, EMAIL } from "./data";

const NAV = [
  { label: "Products", href: "#products" },
  { label: "About Us", href: "#about" },
  { label: "Applications", href: "#applications" },
  { label: "Bulk Supply", href: "#bulk-supply" },
  { label: "Download App", href: "#app" },
  { label: "Get Quotation", href: "#quotation" },
];

export const Footer = () => (
  <footer data-testid="site-footer" className="relative overflow-hidden border-t border-emerald-900/40 bg-[#050B07]">
    <p className="font-display pointer-events-none select-none whitespace-nowrap text-center text-[22vw] font-extrabold uppercase leading-none text-emerald-500/5">
      KARM
    </p>

    <div className="container mx-auto -mt-[8vw] grid grid-cols-1 gap-10 px-4 pb-12 sm:px-6 md:grid-cols-3 lg:px-8">
      <div>
        <div className="flex items-center gap-3">
          <img src={IMAGES.logo} alt="KARM INDUSTRIES logo" className="h-12 w-12 rounded-full object-cover" />
          <div>
            <p className="font-display text-lg font-extrabold tracking-wide text-white">KARM INDUSTRIES</p>
            <p className="font-mono2 text-[11px] uppercase tracking-[0.25em] text-emerald-400">Green Fuel | Clean Future</p>
          </div>
        </div>
        <p className="mt-5 max-w-xs text-sm leading-relaxed text-slate-400">
          Premium bio pellet manufacturer from Katni, Madhya Pradesh — powering
          India&apos;s industries with clean, carbon-natural fuel.
        </p>
      </div>

      <div>
        <p className="font-mono2 text-xs font-bold uppercase tracking-[0.25em] text-emerald-500">Explore</p>
        <nav className="mt-5 grid grid-cols-2 gap-x-6 gap-y-3" data-testid="footer-nav">
          {NAV.map((n) => (
            <a key={n.href} href={n.href} data-testid={`footer-link-${n.label.toLowerCase().replace(/[^a-z]+/g, "-")}`} className="text-sm text-slate-400 transition-colors hover:text-emerald-400">
              {n.label}
            </a>
          ))}
        </nav>
      </div>

      <div>
        <p className="font-mono2 text-xs font-bold uppercase tracking-[0.25em] text-emerald-500">Contact</p>
        <div className="mt-5 space-y-3 text-sm text-slate-300">
          <a href={PHONE_TEL} data-testid="footer-phone-link" className="flex items-center gap-3 transition-colors hover:text-emerald-400">
            <Phone className="h-4 w-4 text-emerald-400" /> {PHONE_DISPLAY}
          </a>
          <a href={WA_LINK} target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp-link" className="flex items-center gap-3 transition-colors hover:text-emerald-400">
            <MessageCircle className="h-4 w-4 text-emerald-400" /> WhatsApp: {PHONE_DISPLAY}
          </a>
          <a href={`mailto:${EMAIL}`} data-testid="footer-email-link" className="flex items-center gap-3 break-all transition-colors hover:text-emerald-400">
            <Mail className="h-4 w-4 shrink-0 text-emerald-400" /> {EMAIL}
          </a>
          <p className="flex items-start gap-3 text-slate-400">
            <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-emerald-400" />
            Plot No. 41, Amkuhi Industrial Area, Katni, Madhya Pradesh, India
          </p>
        </div>
      </div>
    </div>

    <div className="border-t border-emerald-900/40">
      <div className="container mx-auto flex flex-col items-center justify-between gap-3 px-4 py-6 text-xs text-slate-500 sm:flex-row sm:px-6 lg:px-8">
        <p data-testid="footer-copyright">© {new Date().getFullYear()} KARM INDUSTRIES. All rights reserved.</p>
        <p className="font-mono2 uppercase tracking-widest">buybiopellets.com · Katni, MP, India</p>
      </div>
    </div>
  </footer>
);
